<form [formGroup]="settingsForm" class="form">
  <div class="form__horizontal-fields">
    <div class="form__field">
      <div class="form__field-inner-wrapper">
        <osp-form-field>
          <osp-label>{{ geoLabel }}</osp-label>
          <osp-dropdown
            [formControlName]="controlNames.SETTINGS_GEOFENCE"
            [options]="$groupedGeofences()"
            [filter]="true"
            [filterBy]="'label'"
            [group]="true"
            [panelStyleClass]="'osp-dropdown-grouped'"
            required
          />
          <osp-error [messages]="{ required: 'shared.validation.requiredField' | translate }" />
        </osp-form-field>
      </div>
    </div>
    <div class="form__field">
      <div class="form__field-inner-wrapper">
        <osp-form-field>
          <osp-label [tooltip]="geoTriggerExplanation">{{ geoTriggerLabel }}</osp-label>
          <osp-dropdown [formControlName]="controlNames.SETTINGS_GEOFENCE_TRIGGER" [options]="triggerOptions" />
          <osp-error [messages]="{ required: 'shared.validation.requiredField' | translate }"></osp-error>
        </osp-form-field>
      </div>
    </div>
  </div>
  <div class="geofence-map-wrapper">
    <div class="map-container">
      <div class="geofences-container on-top">
        @if (allowedToCreateGeofence()) {
          <osp-button
            [category]="'secondary'"
            [icon]="resolveAddGeofenceButtonIcon()"
            [tooltip]="'modules.notification.alarmRuleAddEdit.button.createGeofence' | translate"
            [tooltipPosition]="'bottom'"
            (click)="toggleCreateMode()"
          ></osp-button>
        }

        <div [ngClass]="{ hidden: !$buttonState() }">
          @if (map() && $buttonState()) {
            <osp-create-geofence-sidebar
              [map]="map()"
              [mapSize]=""
              [loading]="false"
              [createEnabled]="true"
              (onCreate)="handleCreateGeofenceAction($event)"
            />
          }
        </div>
      </div>

      <osp-map
        class="map-geofence"
        [latitude]="initialCenter()?.lat"
        [longitude]="initialCenter()?.lng"
        (mapInitialized)="mapReady($event)"
      />
    </div>
  </div>
</form>
